import {AfterViewInit, Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormControl, FormGroup, ReactiveFormsModule, Validators, FormsModule} from '@angular/forms';
import {phoneValidator, ValidateEmail, zipValidator} from 'src/app/validators/form-validator';
import {stateValidator} from 'src/app/validators/state.validator';
import {GrievanceRequestInterface} from 'src/app/interfaces/grievance-request.interface';
import {PlansService} from 'src/app/services/plans.service';
import {ObjToKeysPipe} from 'src/app/pipes/objToKeys';
import {NgxMaskDirective} from 'ngx-mask';
import {NgIf, NgFor} from '@angular/common';
import {EventsManager} from 'src/app/services/events.manager';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-grievance-form',
  templateUrl: './grievance-form.component.html',
  styleUrl: './grievance-form.component.scss',
  imports: [FormsModule, ReactiveFormsModule, NgIf, NgFor, NgxMaskDirective, ObjToKeysPipe]
})

export class GrievanceFormComponent implements OnInit, AfterViewInit  {
  private _plansService = inject(PlansService);
  private _activatedRoute = inject(ActivatedRoute);
  private _destroyRef = inject(DestroyRef);
  protected _eventsManager = inject(EventsManager);

  public gForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    otherName: new FormControl(''),
    address1: new FormControl('', [Validators.required, Validators.minLength(4)]),
    city: new FormControl('', [Validators.required]),
    state: new FormControl('', [stateValidator(), Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
    zipCode: new FormControl('', [zipValidator, Validators.required]),
    email: new FormControl('', [Validators.required, ValidateEmail]),
    phoneNumber: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(13), phoneValidator]),
    officeName: new FormControl('', [Validators.required]),
    officeAddress1: new FormControl('', [Validators.required, Validators.minLength(4)]),
    officeCity: new FormControl('', [Validators.required]),
    officeState: new FormControl('', [stateValidator(), Validators.required, Validators.minLength(2), Validators.maxLength(2)]),
    officeZipCode: new FormControl('', [zipValidator, Validators.required]),
    officePhoneNumber: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(13), phoneValidator]),
    officeEmail: new FormControl('', [Validators.required, ValidateEmail]),
    message: new FormControl('', [Validators.required])
  });
  public showSuccessMessage: boolean = false;
  public brand: string = 'sgdp';

  public ngOnInit(): void {
    const url: string = this._activatedRoute.snapshot.url.join('|');

    if (url.includes('adha')) {
      this._eventsManager.purchaseIsADHA = true;
      this._eventsManager.setHideHeader(true);
    }
  }

  public ngAfterViewInit() {
    window.scroll(0, -window.scrollY);
  }

  public sendForm() {
    if (this._eventsManager.purchaseIsADHA) {
      this.brand = 'adha';
    }

    const request: GrievanceRequestInterface = {
      memberInfo: {
        firstName: this.gForm.get('firstName')?.value,
        lastName: this.gForm.get('lastName')?.value,
        email: this.gForm.get('email')?.value,
        phone: this.gForm.get('phoneNumber')?.value,
        mainSubscriber: this.gForm.get('otherName')?.value,
        address:{
          streetAddress:this.gForm.get('address')?.value,
          city:this.gForm.get('city')?.value,
          state:this.gForm.get('state')?.value,
          zip:this.gForm.get('zipCode')?.value
        }
      },
      dentistInfo:{
        name:this.gForm.get('officeName')?.value,
        phone:this.gForm.get('officePhoneNumber')?.value,
        address:{
          streetAddress:this.gForm.get('officeAddress')?.value,
          city:this.gForm.get('officeCity')?.value,
          state:this.gForm.get('officeState')?.value,
          zip:this.gForm.get('officeZipCode')?.value
        }
      },
      grievanceDescription:this.gForm.get('message')?.value,
      brand:this.brand
    };
    this._plansService.sendGrievanceForm(request).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this.showSuccessMessage = true;
      window.scroll(0, 0);
    });
  }

  public translateError(error: string) {
    let returnError: string = '';
    switch (error) {
      case 'minlength':
        returnError = 'Field is not long enough';
        break;
      case 'invalidPhone':
        returnError = 'Phone Number is not valid';
        break;
      case 'invalidEmail':
        returnError = 'Email is not valid';
        break;
      case 'invalidDate':
        returnError = 'The Date provided is invalid';
        break;
      case 'notAnAdult':
        returnError = 'The responsible party cannot be a minor';
        break;
      case 'incorrectState':
        returnError = 'State is not a valid State';
        break;
      case 'invalidZip':
        returnError = 'ZipCode is not valid';
        break;
      case 'required':
        returnError = 'Field is required';
        break;
      default:
        returnError = 'Field is not valid';
        break;
    }
    return returnError;
  }
}
